import { Link } from "@inertiajs/react";
import { useState } from "react";

import PdfViewerSheet from "@/components/pdf-viewer-sheet";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { formatCurrency } from "@/helpers/currency-formatter";
import type { Quote } from "@/types";

interface QuoteHistoryDialogProps {
  supplierName: string;
  purchaseRequestId: number;
  versions: Quote[];
}

export default function HistoryDialog({
  supplierName,
  purchaseRequestId,
  versions,
}: QuoteHistoryDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm">
          Historial ({versions.length})
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Historial de cotizaciones — {supplierName}</DialogTitle>
          <DialogDescription>
            Versiones anteriores cargadas por el proveedor
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {versions.map((v) => (
            <div key={v.id} className="flex items-center justify-between rounded border p-3">
              <div className="min-w-0">
                <div className="text-sm font-medium truncate">
                  #{v.quote_number ?? v.id} — {v.quote_date}
                </div>
                <div className="text-xs text-muted-foreground">
                  {formatCurrency(v.total_amount, v.currency)}
                  {v.currency === 'USD' && v.total_in_ars ? ` · ${formatCurrency(v.total_in_ars, 'ARS')}` : ''}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <ButtonGroup>
                  <Button variant="outline" size="sm" asChild>
                    <Link href={`/purchase_requests/${purchaseRequestId}/quotes/${v.id}`}>
                      Ver Cotización
                    </Link>
                  </Button>
                  {v.pdf?.url && (
                    <PdfViewerSheet
                      pdfUrl={v.pdf.url}
                      title={`Cotización ${v.quote_number ?? `#${v.id}`} - ${supplierName}`}
                      triggerText="Ver documento"
                    />
                  )}
                </ButtonGroup>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
